import React from 'react';
import Link from 'next/link';
import { stripPreSlash } from '@/utils/slash-utils';
import type { ExtractProps } from '@/utils/props';

export function MarkdownButton({
  text,
  href = '',
  svgIcon,
  variant = 'default',
}: {
  text: string;
  href: string;
  svgIcon?: string;
  variant?: string;
} & ExtractProps<typeof Link>): React.JSX.Element | null {
  const isExternal = href.startsWith('http');
  const slug = isExternal ? href : `/${stripPreSlash(href)}`;

  if (!slug || !text) {
    return null;
  }

  let style = 'bg-blue-700 hover:bg-blue-700 focus:ring-4 focus:ring-blue-800';
  if (variant === 'secondary') {
    style =
      'border border-gray-600 hover:border-gray-600 bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:ring-gray-700';
  }

  return (
    <p className='w-full text-center'>
      <Link
        className={`inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white not-prose rounded-lg ${style}`}
        href={slug}
        rel={isExternal ? 'noopener noreferrer' : undefined}
        target={isExternal ? '_blank' : undefined}>
        {svgIcon ? (
          <>
            <span dangerouslySetInnerHTML={{ __html: svgIcon }} />
            &nbsp;{' '}
          </>
        ) : null}
        {text}
      </Link>
    </p>
  );
}
